import { handleDownload } from "../../../Reusables/components/TemplateDownload/TemplateDownload.utils";
import { makeCygnusApiCall } from "../../../api/api";
import { SelectOption, PopulateResult } from "./UploadSpreadsheetModal.types";
import { CustomToaster } from "../../reusable_components/Toasters/toaster";

export const populateTemplate = async (
  file: File,
  selectedOption: SelectOption,
  refresh: () => void,
  onHide: () => void,
  setFileUploading: (val: boolean) => void,
  continueTransformation: boolean = false
): Promise<PopulateResult> => {
  try {
    setFileUploading(true);

    const formData = new FormData();
    formData.append("SpreadsheetFile", file);
    formData.append("LineOfServiceCode", selectedOption.id);
    formData.append("LineOfServiceLabel", selectedOption.label);

    if (continueTransformation) {
      formData.append("ContinueTransformation", "true");
    }

    const endpoint = "/clients/client_bulk_spreadsheets/";
    const transformedFileName = `${selectedOption.label}_Transformed`;
    const extension = "xlsx";

    if (continueTransformation) {
      const dummySetter = () => {};

      await handleDownload(
        endpoint,
        formData,
        transformedFileName,
        extension,
        dummySetter,
        true
      );

      onHide();
      return "SUCCESS";
    }

    const response = await makeCygnusApiCall({
      type: "POST",
      url: endpoint,
      payload: formData,
      payload_is_file: true,
      forMDM: true,
      show_message: false,
    });

    if (response?.data?.InvalidSpreadsheet === true) {
      return "INVALID_SPREADSHEET";
    }

    if (!response?.success) {
      CustomToaster({
        type: "error",
        customized_message:
          response?.message || "File Initialization Failed.",
        api_message: "",
      });
      return "FAILED";
    }

    CustomToaster({
      type: "success",
      customized_message:
        response?.message || "File Initialized successfully!",
      api_message: "",
    });

    refresh();
    onHide();
    return "SUCCESS";

  } catch (err: any) {
    CustomToaster({
      type: "error",
      customized_message:
        err?.message || "Something went wrong while uploading.",
      api_message: "",
    });

    return "FAILED";
  } finally {
    setFileUploading(false);
  }
};